import * as types from './user.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	get: payload => ({
		type: types.GET_USER,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_USER,
		payload,
	}),
	set: payload => ({
		type: types.SET_USER,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_USER,
		payload,
	}),
	remove: payload => ({
		type: types.DELETE_USER,
		payload,
	}),
	getStaticOptions: () => ({
		type: types.GET_STATIC_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
	setErrors: payload => ({
		type: types.SET_ERRORS,
		payload,
	}),
}
